export default ['de', 'fr', 'it', 'en'];
export const defaultLanguage = 'de';
export const cmsLanguage = 'en';
